/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { Job } from '../model/job';
import { JobCreateRequest } from '../model/jobCreateRequest';
import { JobDeleteRequest } from '../model/jobDeleteRequest';
import { JobSignalRequest } from '../model/jobSignalRequest';
import { JobSummaries } from '../model/jobSummaries';
import { JobUpdateRequest } from '../model/jobUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class JobService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createJob
     * Creates and starts a new job asynchronously. &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param jobCreateRequest the information needed to create the job.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobCreateJob(jobCreateRequest: JobCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<Job>;
    public jobCreateJob(jobCreateRequest: JobCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Job>>;
    public jobCreateJob(jobCreateRequest: JobCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Job>>;
    public jobCreateJob(jobCreateRequest: JobCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (jobCreateRequest === null || jobCreateRequest === undefined) {
            throw new Error('Required parameter jobCreateRequest was null or undefined when calling jobCreateJob.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Job>(`${this.configuration.basePath}/jobs`,
            jobCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteJob
     * Deletes a currently running job and preserves the job state in history. &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param id The job id
     * @param jobDeleteRequest The delete request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobDeleteJob(id: string, jobDeleteRequest: JobDeleteRequest, observe?: 'body', reportProgress?: boolean): Observable<Job>;
    public jobDeleteJob(id: string, jobDeleteRequest: JobDeleteRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Job>>;
    public jobDeleteJob(id: string, jobDeleteRequest: JobDeleteRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Job>>;
    public jobDeleteJob(id: string, jobDeleteRequest: JobDeleteRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobDeleteJob.');
        }
        if (jobDeleteRequest === null || jobDeleteRequest === undefined) {
            throw new Error('Required parameter jobDeleteRequest was null or undefined when calling jobDeleteJob.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<Job>(`${this.configuration.basePath}/jobs/ids/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getJob
     * Gets the details of a previously submitted job. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param id the job id.
     * @param verbose 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobGetJob(id: string, verbose?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Job>;
    public jobGetJob(id: string, verbose?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Job>>;
    public jobGetJob(id: string, verbose?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Job>>;
    public jobGetJob(id: string, verbose?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobGetJob.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (verbose !== undefined && verbose !== null) {
            queryParameters = queryParameters.set('verbose', <any>verbose);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Job>(`${this.configuration.basePath}/jobs/ids/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getJobs
     * &lt;p&gt;Gets a list of job executions based on the specified filter parameters.&lt;/p&gt; &lt;p&gt;Jobs&#39; namespace to which you do not have READ permissions to will be omitted from the result.&lt;/p&gt;
     * @param namespace an optional namespace filter
     * @param jobName an optional job name filter
     * @param status an optional job status filter
     * @param startTime an optional start time filter (ex. 2015, 2015-12, 2015-12-28, 2015-12-12T3:4:5)
     * @param endTime an optional end time filter (ex. 2015, 2015-12, 2015-12-28, 2015-12-12T3:4:5)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobGetJobs(namespace?: string, jobName?: string, status?: 'RUNNING' | 'SUSPENDED' | 'COMPLETED', startTime?: string, endTime?: string, observe?: 'body', reportProgress?: boolean): Observable<JobSummaries>;
    public jobGetJobs(namespace?: string, jobName?: string, status?: 'RUNNING' | 'SUSPENDED' | 'COMPLETED', startTime?: string, endTime?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobSummaries>>;
    public jobGetJobs(namespace?: string, jobName?: string, status?: 'RUNNING' | 'SUSPENDED' | 'COMPLETED', startTime?: string, endTime?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobSummaries>>;
    public jobGetJobs(namespace?: string, jobName?: string, status?: 'RUNNING' | 'SUSPENDED' | 'COMPLETED', startTime?: string, endTime?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (namespace !== undefined && namespace !== null) {
            queryParameters = queryParameters.set('namespace', <any>namespace);
        }
        if (jobName !== undefined && jobName !== null) {
            queryParameters = queryParameters.set('jobName', <any>jobName);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (startTime !== undefined && startTime !== null) {
            queryParameters = queryParameters.set('startTime', <any>startTime);
        }
        if (endTime !== undefined && endTime !== null) {
            queryParameters = queryParameters.set('endTime', <any>endTime);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<JobSummaries>(`${this.configuration.basePath}/jobs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * signalJob
     * Signals the job with the receive task. &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param jobSignalRequest the information needed to signal the job.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobSignalJob(jobSignalRequest: JobSignalRequest, observe?: 'body', reportProgress?: boolean): Observable<Job>;
    public jobSignalJob(jobSignalRequest: JobSignalRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Job>>;
    public jobSignalJob(jobSignalRequest: JobSignalRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Job>>;
    public jobSignalJob(jobSignalRequest: JobSignalRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (jobSignalRequest === null || jobSignalRequest === undefined) {
            throw new Error('Required parameter jobSignalRequest was null or undefined when calling jobSignalJob.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Job>(`${this.configuration.basePath}/jobs/signal`,
            jobSignalRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateJob
     * Activates or suspends a job execution. &lt;p&gt;Requires EXECUTE permission on namespace&lt;/p&gt;
     * @param id the job id
     * @param jobUpdateRequest the job update request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobUpdateJob(id: string, jobUpdateRequest: JobUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<Job>;
    public jobUpdateJob(id: string, jobUpdateRequest: JobUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Job>>;
    public jobUpdateJob(id: string, jobUpdateRequest: JobUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Job>>;
    public jobUpdateJob(id: string, jobUpdateRequest: JobUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling jobUpdateJob.');
        }
        if (jobUpdateRequest === null || jobUpdateRequest === undefined) {
            throw new Error('Required parameter jobUpdateRequest was null or undefined when calling jobUpdateJob.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Job>(`${this.configuration.basePath}/jobs/ids/${encodeURIComponent(String(id))}`,
            jobUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
